import { DataConnection } from '@/apis/data_connectors/types';
import { customFetch } from '@/lib/utils';

export interface TeamDataConnection {
  id: string;
  teamId: string;
  dataConnectionId: string;
}

export const getTeamDataConnections = async ({
  teamId,
  accessToken
}): Promise<DataConnection[]> => {
  const response = await customFetch(`/backend/teams/${teamId}/data-connectors`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) throw await response.json();

  return (await response.json()) as DataConnection[];
};

export const shareConnectionWithTeam = async ({
  teamId,
  connectionId,
  accessToken
}): Promise<TeamDataConnection> => {
  const response = await customFetch(
    `/backend/teams/${teamId}/data-connectors/${connectionId}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      method: 'POST'
    }
  );

  if (!response.ok) throw await response.json();

  return (await response.json()) as TeamDataConnection;
};

export const unshareConnectionWithTeam = async ({
  teamId,
  connectionId,
  accessToken
}): Promise<{ success: boolean }> => {
  const response = await customFetch(
    `/backend/teams/${teamId}/data-connectors/${connectionId}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      method: 'DELETE'
    }
  );

  if (!response.ok) throw await response.json();

  return (await response.json()) as { success: boolean };
};
